import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {combineLatest, Observable} from 'rxjs';
import {AuthService} from "../auth.service";
import {StatusEnum} from "@enums/statusEnum";
import {appRoutingEnum} from "@enums/appRoutingEnum";
import {map} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class ChangePhotoGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.auth.getIsLogin() || this.auth.getStatus() == StatusEnum.NO_IMG) {
      return true;
    }
    return combineLatest([this.auth.getIsLoginFromStorage(), this.auth.getStatusFromStorage()]).pipe(
      map(([isLogin, status]) => (isLogin || status == StatusEnum.NO_IMG) ? true : this.router.parseUrl(appRoutingEnum.MAIN))
    )
  }

}
